import React from "react"
import S from "./CartLabels.module.scss"


const CartLabels = () => {

  // the container has been named labels as there is a bug in gatsby that strips out styles if it is div
  return (
    <ul className={S.cartlabels}>
      <div >ITEM</div>
      <div>PRICE</div>
      <div>QTY</div>
      <div>SUBTOTAL</div>
    </ul>
  )
}

export default CartLabels
